var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKhtGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.45,97.66c-2.89-2.36-6.33-3.87-9.96-4.73-9.35-2.2-16.32-10.61-16.32-20.61V22C10.16,10.3,19.64.82,31.34.82h50.33c11.69,0,21.17,9.48,21.17,21.17v50.33c0,10.01-6.98,18.41-16.32,20.61-3.63.85-7.07,2.37-9.96,4.73l-16.09,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.51,10.2h50.15c6.51,0,11.8,5.29,11.8,11.8v50.33c0,6.51-5.29,11.8-11.8,11.8H31.34c-6.51,0-11.8-5.29-11.8-11.8V22.17c0-6.61,5.37-11.97,11.97-11.97Z",
    fill: "url(#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(27.33 48.5)",
    fill: "#0489b2",
    fontFamily: "MinionVariableConcept-Roman, 'Minion Variable Concept'",
    fontSize: 22.28,
    "font-variation-settings": "'wght' 400, 'opsz' 11"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".07em"
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.13,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 20.9,
    y: 0,
    letterSpacing: "0em"
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.61,
    y: 0,
    letterSpacing: "-.09em"
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 41.33,
    y: 0,
    letterSpacing: "-.08em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.56,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(34.46 62.12)",
    fill: "#0489b2",
    fontFamily: "MinionVariableConcept-Roman, 'Minion Variable Concept'",
    fontSize: 15.05,
    "font-variation-settings": "'wght' 400, 'opsz' 11"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-.03em"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.2,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.96,
    y: 0,
    letterSpacing: "-.02em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.28,
    y: 0,
    letterSpacing: "0em"
  }, "or"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.46,
    y: 0
  }, "s")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhtGrey);
export default __webpack_public_path__ + "static/media/KHT_grey.f86dfd51bc60df5b10d2c8d09442e4ed.svg";
export { ForwardRef as ReactComponent };